import React from "react";
import { Modal } from "react-bootstrap";
import UserIcons from "../../images/user.png";

const Attendees = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      className="attendees-popup"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>
          Attendees<span className="count">({props?.count})</span>
        </h4>
        <ul className="attendees-list-cover">
          {props?.data?.map(({ users_view }) => {
            return (
              <li>
                <div className="user-photo">
                  <img
                    src={users_view?.profile_photo || UserIcons}
                    alt="user photo"
                  />
                </div>
                <p>{users_view?.full_name}</p>
              </li>
            );
          })}
        </ul>
      </Modal.Body>
    </Modal>
  );
};

export default Attendees;
